import React from 'react';
import ReactDOM from 'react-dom/client';
import { HashRouter } from 'react-router-dom';
import App from './App';
import './styles/global.css';

// Using HashRouter rather than BrowserRouter so we don't need SPA-rewrite rules
// in the root-level staticwebapp.config.json. URLs look like /dashboard/#/test —
// fine for an internal ops dashboard, zero server-side routing config needed.
ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <HashRouter>
      <App />
    </HashRouter>
  </React.StrictMode>,
);
